console.log(
  "\n%cby Mariano Álvarez\n%cwww.dev.creativoma.com%c\n\n",
  "font-size: 25px; color:#221ab2; font-weight:600; font-family: Inter, sans-serif",
  '<a href="https://dev.creativoma.com/" target="_blank" style="font-size: 20px; font-family: Inter, sans-serif">',
  "</a><hr/>",
);
